import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { patch } from '../../../redux/api';
import type { CustomSeverityScope } from '../../../../shared/model-typings/customseverity';
import type {
  UpdateCustomSeverityRequestBody,
  UpdateSeverityResponse,
} from '../../../../shared/types/routes/customSeverities';

type UpdateCustomRiskScoreVariables = {
  issueId: number;
  body: UpdateCustomSeverityRequestBody;
  scope: {
    type: CustomSeverityScope;
    id: string;
  };
};

const updateCustomRiskScore = ({ issueId, body, scope }: UpdateCustomRiskScoreVariables) =>
  patch<UpdateCustomSeverityRequestBody, UpdateSeverityResponse>(
    `/api/custom-risk-scores/${issueId}`,
    body,
    { query: { scope } },
  );

/**
 * Hook for updating a custom risk score on an issue.
 */
export default function useUpdateCustomRiskScore() {
  return useToastedMutation({
    mutationFn: updateCustomRiskScore,
    successToastMessage: 'Custom risk score updated successfully',
    errorToastMessage: 'Failed to update custom risk score',
  });
}
